'use strict';

var angular = require('angular');


module.exports = angular
	.module('flxSubPlansTable', [])
	.directive('flxSubPlansTable', require('./flxSubPlansTableDirective'))
	.controller('SPTableCtrl', require('./flxSubPlansTableController'))
	;